import React from 'react';
import {FIND_ALL_BANCOS as query} from '../../graphql/queries';
import {SelectBase} from '../../components/select/mui-base';

const transformOptions = ({content}) => {
  return Array.isArray(content)
    ? content.map(item => ({
      ...item,
      label: item.codigoENome,
      value: item.id
    }))
    : [];
};

const getVariables = ({pageNumber, search = '', searchDTO = {}, pageSize = 20}) => {
  return {
    pageable: {pageNumber, pageSize, sortField: 'codigoBanco', sortDir: 'ASC'},
    searchDTO: {
      ...searchDTO,
      search
    }
  };
};

export const SelectBancos = (props) => {
  return (
    <SelectBase
      label="Banco"
      responseObjectName="bancos"
      transformOptions={transformOptions}
      getVariables={(searchProps) => getVariables({...searchProps, ...props})}
      query={query}
      {...props}
    />
  );
};
